import { ButtonRouterLink } from '../primitives';
import './SettingsBackLink.css';

export function SettingsBackLink() {
  return (
    <div className="set-sub-back" data-testid="settings-back-link">
      <ButtonRouterLink
        to="/settings"
        variant="ghost"
        state={{ routeTransition: 'back' }}
      >
        ← Settings
      </ButtonRouterLink>
    </div>
  );
}
